module.exports = __webpack_public_path__ + "5f1e60b1b9be3b2289c59e91326099f7.svg";